module.exports = __webpack_public_path__ + "img/9_uk.1c1cae8c.svg";